var map = {
	"./autorizaciones.png": 1037,
	"./cartillas.png": 1038,
	"./credencialprovi.png": 1039,
	"./e_consulta.png": 1040,
	"./facturas.png": 1041,
	"./historial.png": 1042,
	"./laboratorio.png": 1043,
	"./mis_datos.png": 1044,
	"./plan.png": 1045,
	"./turnos.png": 1046
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;


//////////////////
// WEBPACK FOOTER
// ./src/components/LeftNavigation/images nonrecursive \.png
// module id = 1036
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13